import { render, staticRenderFns } from "./WorkspaceEdgeInspectorContent.vue?vue&type=template&id=1080ab51&scoped=true"
import script from "./WorkspaceEdgeInspectorContent.vue?vue&type=script&lang=js"
export * from "./WorkspaceEdgeInspectorContent.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceEdgeInspectorContent.vue?vue&type=style&index=0&id=1080ab51&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1080ab51",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1080ab51')) {
      api.createRecord('1080ab51', component.options)
    } else {
      api.reload('1080ab51', component.options)
    }
    module.hot.accept("./WorkspaceEdgeInspectorContent.vue?vue&type=template&id=1080ab51&scoped=true", function () {
      api.rerender('1080ab51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceEdgeInspectorContent.vue"
export default component.exports